const config = {
  development: {
    API_BASE_URL: "http://safsimsapi.safsims-dev.com",
    SCHOOL_URL: ".safsims-dev.com",
  },
  staging: {
    API_BASE_URL: "https://api.safsims-stage.com",
    SCHOOL_URL: ".safsims-stage.com",
  },
  production: {
    API_BASE_URL: "https://api.production.safsims.com",
    SCHOOL_URL: ".safsims.com",
  },
};

export default config[process.env.REACT_APP_ENV || process.env.NODE_ENV];
